import { ComponentType, FunctionComponent, useContext } from 'react'
import { Redirect, useLocation } from 'react-router-dom'

import { AuthContext } from '@medable/medable-web-framework'
import { AuthContextType } from '@medable/medable-web-framework/dist/contexts/AuthContext'

import { Routes } from '@/components/router'
import { Loading } from '@/components/loading'
import { Layout } from '@/components/layout'

interface PrivateRouteProps {
  Component: ComponentType
}

export const PrivateRoute: FunctionComponent<PrivateRouteProps> = (props: PrivateRouteProps) => {
  const { Component } = props

  const { isLoggedIn, loading, refreshing } = useContext<AuthContextType>(AuthContext)
  const location = useLocation()

  if (!refreshing && !loading && !isLoggedIn) {
    return <Redirect to={{ pathname: Routes.LOGIN, state: { from: location } }} />
  }

  return refreshing || loading ? (
    <Loading />
  ) : (
    <Layout>
      <Component />
    </Layout>
  )
}
